(function () {
  if (window.__pdpUpsellLoaded) return;
  window.__pdpUpsellLoaded = true;

  function init(root) {
    if (!root || root.dataset.upsellInitialized === 'true') return;
    root.dataset.upsellInitialized = 'true';

        const moneyEl = root.querySelector('[data-upsell-money]');
        const moneyFormat = moneyEl ? JSON.parse(moneyEl.textContent || '""') : (window.gwaMoneyFormat || '');

        const CART_ADD_URL = root.getAttribute('data-cart-add-url') || '/cart/add';

        const addingLabel = root.getAttribute('data-adding-label') || 'Adding...';
        const moreLabel = root.getAttribute('data-more-label') || 'more';
        const lessLabel = root.getAttribute('data-less-label') || 'less';
        const soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
        const freeLabel = root.getAttribute('data-free-label') || 'Gratis';
        const addFailedLabel = root.getAttribute('data-add-failed-label') || 'Add to cart failed';
        const errorLabel = root.getAttribute('data-error-label') || 'Error';

        const formatMoney = (cents) => {
          if (Number(cents || 0) === 0) return freeLabel;
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(cents, moneyFormat);
          }
          return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
        };

        async function addToCartAjax(variantId) {
          const res = await fetch(CART_ADD_URL + '.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1
            })
          });

          const data = await res.json().catch(() => null);

          if (!res.ok || !data) {
            throw new Error(data?.description || addFailedLabel);
          }

          return data;
        }

        async function addItemsToCartAjax(items) {
          const res = await fetch(CART_ADD_URL + '.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const data = await res.json().catch(() => null);

          if (!res.ok || !data) {
            throw new Error(data?.description || addFailedLabel);
          }

          return data;
        }

        function getSectionsUrl(sectionIds) {
          const rootUrl = window.Shopify?.routes?.root || '/';
          return `${rootUrl}?sections=${sectionIds.join(',')}`;
        }

        function parseHTML(html) {
          return new DOMParser().parseFromString(html || '', 'text/html');
        }

        function closeCartDrawer(drawer) {
          const host = drawer || document.querySelector('cart-drawer');
          if (!host) return;

          host.classList.remove('active', 'animate', 'is-open', 'open');
          host.setAttribute('aria-hidden', 'true');

          document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
          document.documentElement.classList.remove('overflow-hidden');
        }

        function openCartDrawer() {
          const drawer = document.querySelector('cart-drawer');

          if (!drawer) {
            const notification = document.querySelector('cart-notification');
            if (notification && typeof notification.open === 'function') notification.open();
            return;
          }

          if (typeof drawer.open === 'function') {
            drawer.open();
            return;
          }

          drawer.classList.add('active', 'animate');
          drawer.removeAttribute('aria-hidden');
          document.body.classList.add('overflow-hidden');
        }

        function bindCartDrawerCloseFallback() {
          if (window.__pupCartDrawerCloseBound) return;
          window.__pupCartDrawerCloseBound = true;

          document.addEventListener('click', function(event) {
            const drawer = document.querySelector('cart-drawer');
            if (!drawer) return;

            const clickedClose = event.target.closest(
              'cart-drawer .drawer__close, cart-drawer [data-drawer-close], cart-drawer [aria-label*="close" i], cart-drawer [aria-label*="schließen" i]'
            );

            const clickedOverlay =
              event.target.classList && (
                event.target.classList.contains('drawer__overlay') ||
                event.target.id && event.target.id.indexOf('CartDrawer-Overlay') === 0
              );

            if (!clickedClose && !clickedOverlay) return;

            event.preventDefault();
            event.stopPropagation();
            closeCartDrawer(drawer);
          }, true);

          document.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape') return;
            const drawer = document.querySelector('cart-drawer.active, cart-drawer.is-open, cart-drawer.open');
            if (drawer) closeCartDrawer(drawer);
          });
        }

        async function refreshCartUI() {
          try {
            const cartRes = await fetch('/cart.js', {
              headers: { 'Accept': 'application/json' }
            });

            const cart = await cartRes.json();

            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart }
            }));

            window.dispatchEvent(new CustomEvent('cart:refresh', {
              detail: { cart }
            }));

            document.dispatchEvent(new CustomEvent('pdp:upsell-added', {
              bubbles: true,
              detail: { cart }
            }));

            try {
              const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
              const sectionsRes = await fetch(getSectionsUrl(sectionIds), {
                headers: { 'Accept': 'application/json' }
              });

              if (sectionsRes.ok) {
                const sections = await sectionsRes.json();

                if (sections['cart-icon-bubble']) {
                  const currentBubble = document.querySelector('#cart-icon-bubble');
                  if (currentBubble) currentBubble.innerHTML = sections['cart-icon-bubble'];
                }

                if (sections['cart-drawer']) {
                  const drawerDoc = parseHTML(sections['cart-drawer']);
                  const nextDrawer = drawerDoc.querySelector('cart-drawer');
                  const currentDrawer = document.querySelector('cart-drawer');

                  if (currentDrawer && nextDrawer) {
                    currentDrawer.className = nextDrawer.className;
                    currentDrawer.innerHTML = nextDrawer.innerHTML;
                  } else {
                    const nextInner = drawerDoc.querySelector('#CartDrawer, .drawer');
                    const currentInner = document.querySelector('cart-drawer #CartDrawer, cart-drawer .drawer, #CartDrawer');
                    if (nextInner && currentInner) currentInner.innerHTML = nextInner.innerHTML;
                  }
                }
              }
            } catch (sectionsError) {
              console.warn('Cart sections refresh failed:', sectionsError);
            }

            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach((el) => {
              if (cart.item_count !== undefined) el.textContent = cart.item_count;
            });

            const bubble = document.querySelector('.cart-count-bubble');
            if (bubble && cart.item_count !== undefined) {
              bubble.style.display = cart.item_count > 0 ? '' : 'none';
            }

            const drawer = document.querySelector('cart-drawer');
            if (drawer && cart.item_count > 0) {
              drawer.classList.remove('is-empty');
            }

            bindCartDrawerCloseFallback();
            openCartDrawer();

            return cart;
          } catch (e) {
            console.warn('Cart UI refresh failed:', e);
            return null;
          }
        }

        root.querySelectorAll('[data-upsell-item]').forEach((item) => {
          const variantsEl = item.querySelector('[data-upsell-variants]');
          const addBtn = item.querySelector('[data-upsell-add]');
          const priceEl = item.querySelector('[data-upsell-price]');

          if (!variantsEl || !addBtn || !priceEl) return;

          let variants = [];
          try {
            variants = JSON.parse(variantsEl.textContent || '[]');
          } catch (error) {
            console.warn('Upsell variants JSON parse failed:', error);
            return;
          }
          if (!variants.length) return;

          const selectedEl = item.querySelector('[data-upsell-selected]');
          const pillsWrap = item.querySelector('[data-upsell-pills]');
          const pills = Array.from(item.querySelectorAll('[data-upsell-pill]'));
          const moreBtn = item.querySelector('[data-upsell-more]');

          const setPillTooltip = (pill) => {
            if (!pill) return;
            const label = String(
              pill.getAttribute('data-value') ||
              pill.getAttribute('title') ||
              pill.getAttribute('aria-label') ||
              ''
            ).trim();

            if (!label) return;
            pill.dataset.swatchTooltip = label;
            pill.setAttribute('aria-label', label);
            pill.removeAttribute('title');
          };

          pills.forEach(setPillTooltip);

          const getSetItems = (variant) => Array.isArray(variant?.set_items)
            ? variant.set_items.filter(entry => Number(entry?.id || 0) > 0)
            : [];

          const getVariantBundlePrice = (variant) => {
            if (!variant) return 0;

            return getSetItems(variant).reduce((total, entry) => {
              const qty = Math.max(0, Number(entry.quantity || 1));
              return total + (Number(entry.price || 0) * qty);
            }, Number(variant.price || 0));
          };

          const isVariantCompositeAvailable = (variant) => {
            if (!variant || !variant.available) return false;
            return getSetItems(variant).every(entry => {
              const qty = Math.max(0, Number(entry.quantity || 1));
              const inventory = Number(entry.inventory_quantity || 0);
              const tracksInventory = !!entry.inventory_management;
              const canContinue = entry.inventory_policy === 'continue';

              return entry.available !== false && (!tracksInventory || canContinue || inventory >= qty);
            });
          };

          const shouldAddAsBundle = (variant) => {
            if (!getSetItems(variant).length) return false;

            return Number(variant.price || 0) === 0 ||
              [variant.option1, variant.option2, variant.option3].some(option => String(option || '').toLowerCase() === 'digital');
          };

          const pickDefault = () => variants.find(isVariantCompositeAvailable) || variants[0];

          const buildBundleCartItems = (variant) => {
            const setItems = getSetItems(variant);
            const bundleKey = 'bndl_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
            const bundlePrice = getVariantBundlePrice(variant);
            const bundleProperties = {
              '_bundle_key': bundleKey,
              '_bundle_title': item.getAttribute('data-upsell-product-title') || '',
              '_bundle_url': item.getAttribute('data-upsell-product-url') || '',
              '_bundle_image': item.getAttribute('data-upsell-product-image') || '',
              '_bundle_price': String(bundlePrice)
            };
            const cartItems = [];

            cartItems.push({
              id: Number(variant.id),
              quantity: 1,
              properties: bundleProperties
            });

            setItems.forEach(entry => {
              const qty = Math.max(0, Number(entry.quantity || 1));
              if (!qty) return;
              cartItems.push({
                id: Number(entry.id),
                quantity: qty,
                properties: bundleProperties
              });
            });

            return cartItems;
          };

          const applyVariant = (variant) => {
            if (!variant) return;

            if (selectedEl) selectedEl.textContent = variant.option1 || '';

            const available = isVariantCompositeAvailable(variant);
            priceEl.textContent = available
              ? '+ ' + formatMoney(getVariantBundlePrice(variant))
              : soldOutLabel;
            addBtn.setAttribute('data-variant-id', String(variant.id));
            addBtn.disabled = !available;
            addBtn.classList.toggle('is-oos', !available);
          };

          if (pills.length && selectedEl) {
            const findVariantByOption1 = (val) => {
              return variants.find(x => x.option1 === val && isVariantCompositeAvailable(x))
                || variants.find(x => x.option1 === val)
                || pickDefault()
                || null;
            };

            const updatePillAvailability = () => {
              pills.forEach(p => {
                const val = p.getAttribute('data-value') || '';
                const variantsForValue = variants.filter(x => x.option1 === val);
                const valueAvailable = variantsForValue.some(isVariantCompositeAvailable);
                p.classList.toggle('is-oos', !valueAvailable);

                let marker = p.querySelector('.pvsel__x');
                if (!valueAvailable && !marker) {
                  marker = document.createElement('span');
                  marker.className = 'pvsel__x';
                  marker.textContent = 'x';
                  p.appendChild(marker);
                } else if (valueAvailable && marker) {
                  marker.remove();
                }
              });
            };

            const setActivePill = (val) => {
              pills.forEach(p => {
                const on = p.getAttribute('data-value') === val;
                p.classList.toggle('is-active', on);
                p.setAttribute('aria-pressed', on ? 'true' : 'false');
              });
            };

            pills.forEach(p => {
              p.addEventListener('click', () => {
                const val = p.getAttribute('data-value') || '';
                const v = findVariantByOption1(val);

                setActivePill(val);
                applyVariant(v);
              });
            });

            updatePillAvailability();

            if (moreBtn && pillsWrap) {
              moreBtn.addEventListener('click', () => {
                const collapsed = pillsWrap.getAttribute('data-collapsed') === '1';
                pillsWrap.setAttribute('data-collapsed', collapsed ? '0' : '1');

                pills.forEach((p, idx) => {
                  if (idx >= 6) p.classList.toggle('is-hidden', !collapsed);
                });

                moreBtn.textContent = collapsed
                  ? lessLabel
                  : moreLabel;
              });
            }

            const initialVariantId = Number(item.getAttribute('data-initial-variant-id') || 0);
            const currentVal = selectedEl.textContent || '';
            const initial = initialVariantId
              ? variants.find(v => Number(v.id) === initialVariantId) || pickDefault()
              : currentVal
                ? variants.find(v => v.option1 === currentVal) || pickDefault()
                : pickDefault();

            applyVariant(initial);
          } else {
            const initialVariantId = Number(item.getAttribute('data-initial-variant-id') || 0);
            const initial = initialVariantId
              ? variants.find(v => Number(v.id) === initialVariantId) || pickDefault()
              : pickDefault();

            applyVariant(initial);
          }

          item.addEventListener('click', (event) => {
            if (event.defaultPrevented) return;

            const interactiveTarget = event.target.closest(
              'a, button, input, select, textarea, label, [data-upsell-add], [data-upsell-pill], [data-upsell-more]'
            );
            if (interactiveTarget) return;

            const productUrl = item.getAttribute('data-upsell-product-url');
            if (!productUrl) return;

            window.location.href = productUrl;
          });

          item.addEventListener('keydown', (event) => {
            if (event.defaultPrevented || (event.key !== 'Enter' && event.key !== ' ')) return;
            if (event.target !== item) return;

            const productUrl = item.getAttribute('data-upsell-product-url');
            if (!productUrl) return;

            event.preventDefault();
            window.location.href = productUrl;
          });

          if (item.getAttribute('tabindex') == null) item.setAttribute('tabindex', '0');
          if (!item.getAttribute('role')) item.setAttribute('role', 'link');

          addBtn.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            if (addBtn.dataset.upsellAdding === 'true') return;

            const variantId = Number(addBtn.getAttribute('data-variant-id') || 0);
            if (!variantId) return;

            const selectedVariant = variants.find(v => Number(v.id) === variantId);
            if (!selectedVariant || !isVariantCompositeAvailable(selectedVariant)) return;

            const prevText = addBtn.textContent;

            addBtn.dataset.upsellAdding = 'true';
            addBtn.disabled = true;
            addBtn.textContent = addingLabel;

            try {
              if (shouldAddAsBundle(selectedVariant)) {
                await addItemsToCartAjax(buildBundleCartItems(selectedVariant));
              } else {
                await addToCartAjax(variantId);
              }
              await refreshCartUI();

              addBtn.textContent = '✓';
              setTimeout(() => {
                addBtn.textContent = prevText;
              }, 900);
            } catch (e) {
              console.warn(e);
              alert(e?.message || errorLabel);
              addBtn.textContent = prevText;
            } finally {
              delete addBtn.dataset.upsellAdding;
              addBtn.disabled = false;
            }
          });
        });
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-upsell]')) {
      init(context);
    }

    context.querySelectorAll('[data-upsell]').forEach(init);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

	  document.addEventListener('shopify:section:load', function (event) {
	    initAll(event.target);
	  });

	  document.addEventListener('pdp:upsell:updated', function (event) {
	    initAll(event.detail && event.detail.root ? event.detail.root : document);
	  });
	})();
